import React from "react";

import {
  Grid,
  GridItem,
  Hero,
  PageSection,
  Skeleton,
  Stack,
  StackItem
} from "@patternfly/react-core";

import "./EducationDirectionHero.css";


const EducationDirectionHeroSkeleton = () => {
  return (
    <Hero
      className="education-direction-hero"
      isGlass
      bodyWidth="100%"
      bodyMaxWidth="100%"
    >
      <PageSection
        className="education-direction-hero__content"
        isWidthLimited
        aria-busy="true"
        aria-label="Pobieranie oferty kształcenia"
      >
        <Grid hasGutter>
          <GridItem
            span={12}
            md={8}
            lg={7}
          >
            <Stack hasGutter>
              <StackItem>
                <Skeleton
                  width="8rem"
                  height="1.5rem"
                />
              </StackItem>

              <StackItem>
                <Stack hasGutter>
                  <StackItem>
                    <Skeleton
                      width="65%"
                      fontSize="2xl"
                    />
                  </StackItem>

                  <StackItem>
                    <Skeleton width="95%" />
                    <Skeleton width="85%" />
                  </StackItem>
                </Stack>
              </StackItem>

              <StackItem>
                <Grid hasGutter>
                  {[0, 1, 2].map((item) => (
                    <GridItem
                      key={item}
                      span={12}
                      sm={4}
                    >
                      <Stack hasGutter>
                        <StackItem>
                          <Skeleton width="45%" />
                        </StackItem>

                        <StackItem>
                          <Skeleton width="85%" />
                        </StackItem>
                      </Stack>
                    </GridItem>
                  ))}
                </Grid>
              </StackItem>

              <StackItem>
                <Skeleton
                  width="14rem"
                  height="2.25rem"
                />
              </StackItem>
            </Stack>
          </GridItem>
        </Grid>
      </PageSection>
    </Hero>
  );
};


export default EducationDirectionHeroSkeleton;